const DEFAULT_FALLBACK_PATH = '/';
const ALLOWED_ORIGINS = [process.env.VUE_APP_COMMERCE_URL, process.env.VUE_APP_PREMIUM_ADMIN_URL, process.env.VUE_APP_ADMIN_REMOTE_URL];

export const sanitizeRedirectPath = (path?: string | null) => {
  if (!path?.trim()) return DEFAULT_FALLBACK_PATH;
  let decodedPath: string;

  try{
    decodedPath = decodeURIComponent(path.trim());
  }catch{
    return DEFAULT_FALLBACK_PATH;
  }

  const dangerousSchemes = ['javascript:', 'data:'];
  const lowerDecodedPath = decodedPath.toLowerCase();
  if (dangerousSchemes.some(scheme => lowerDecodedPath.startsWith(scheme))) {
    return DEFAULT_FALLBACK_PATH;
  }

  /** path가 아닌 url로 오는 경우 */
  try {
    const url = new URL(decodedPath);

    // full URL일 경우 → origin이 허용 목록에 있으면 통과
    if (ALLOWED_ORIGINS.includes(url.origin)) {
      return url.href;
    } else {
      return DEFAULT_FALLBACK_PATH;
    }
  } catch {}

  return decodedPath;
};